import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { SecondaryButton } from '@/components/ui/Button/Button';

import { useRejectSpecContract } from './reject-spec-contract.hook';

interface RejectSpecContractButtonProps {
  kind: SpecContractType | PaidSpecContractType;
}

const RejectSpecContractButton: FC<RejectSpecContractButtonProps> = ({
  kind,
}) => {
  const buttonProps = useRejectSpecContract(kind);
  const { t } = useTranslation();

  return (
    <SecondaryButton
      {...buttonProps}
      className={'mx-4 !w-[calc(100%_-_2rem)] mb-4'}
      text={t('Next time')}
    />
  );
};

export { RejectSpecContractButton };
